import apiClient from "@/api/client";

export interface SystemAccessType {
  id: string;
  name: string;
  default_checked: boolean;
  is_active: boolean;
  created_at: string;
  updated_at: string;
}

export interface EmployeeSystemAccess {
  id: string;
  employee: string;
  access_type: string;
  access_type_name: string;
  is_checked: boolean;
  created_at: string;
  updated_at: string;
}

export interface AccessibleEmployee {
  id: string;
  first_name: string;
  last_name: string;
  email: string;
  role: string;
  is_ceo: boolean;
  is_active: boolean;
  branch: { id: string; name: string } | null;
}

const wrap = <T>(res: { data: { data: T } }) => res.data.data;

export const systemAccessTypesApi = {
  list: () =>
    apiClient
      .get<{ data: SystemAccessType[] }>("/auth/system-access-types/")
      .then(wrap),

  create: (data: { name: string; default_checked: boolean }) =>
    apiClient
      .post<{ data: SystemAccessType }>("/auth/system-access-types/", data)
      .then(wrap),

  delete: (id: string) =>
    apiClient.delete(`/auth/system-access-types/${id}/`),
};

export const systemAccessesApi = {
  visibleEmployees: () =>
    apiClient
      .get<{ data: AccessibleEmployee[] }>("/auth/system-accesses/visible-employees/")
      .then(wrap),

  list: () =>
    apiClient
      .get<{ data: EmployeeSystemAccess[] }>("/auth/system-accesses/")
      .then(wrap),

  create: (data: { employee: string; access_type: string; is_checked: boolean }) =>
    apiClient
      .post<{ data: EmployeeSystemAccess }>("/auth/system-accesses/", data)
      .then(wrap),

  patch: (id: string, data: { is_checked: boolean }) =>
    apiClient
      .patch<{ data: EmployeeSystemAccess }>(`/auth/system-accesses/${id}/`, data)
      .then(wrap),

  delete: (id: string) =>
    apiClient.delete(`/auth/system-accesses/${id}/`),
};
